import { render, staticRenderFns } from "./TiktokIcon.vue?vue&type=template&id=73859fe3&scoped=true"
import script from "./TiktokIcon.vue?vue&type=script&lang=js"
export * from "./TiktokIcon.vue?vue&type=script&lang=js"
import style0 from "./TiktokIcon.vue?vue&type=style&index=0&id=73859fe3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73859fe3",
  null
  
)

export default component.exports